export class TypePoint {
     nePasInclureDocuments: boolean;
     inclureDansOj: boolean;
     description: string;
     utilisable: boolean;
     profilUtilisationId: number;
     profilVisualisationId: number;
     tri: string;
     id:number;
     constructor(data:any) {
          Object.assign(this, data);
     }
}
 